var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74756 7.50031V12.0031C2.74756 12.2794 2.97156 12.5034 3.24787 12.5034H5.49928C5.63743 12.5034 5.74943 12.3914 5.74943 12.2533V10.252C5.74943 9.56124 6.30943 9.00124 7.00021 9.00124C7.691 9.00124 8.251 9.56124 8.251 10.252V12.2533C8.251 12.3914 8.36299 12.5034 8.50115 12.5034H10.7526C11.0289 12.5034 11.2529 12.2794 11.2529 12.0031V7.75046",
    stroke: "#005DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24658 7.25018L7.00018 1.49658L12.7538 7.25018",
    stroke: "#005DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.02db7033bcbad60df656cf41d260a6e0.svg";
export { ForwardRef as ReactComponent };